import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  MenuItem,
  Paper,
  Select,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { RCSetting } from "./Settings";
import { ExpandMore, Settings } from "@mui/icons-material";
import { useState } from "react";

export default function SettingView({
  setting,
  updateSetting,
}: {
  setting: RCSetting;
  updateSetting: (
    name: string,
    type: string,
    value: any,
    index: number
  ) => void;
}) {
  const [expanded, setExpanded] = useState(false);

  const gray = "#898989FF";

  function inputControl(isNumber: boolean) {
    return (
      <TextField
        placeholder={setting.name}
        value={setting.value}
        type={isNumber ? "number" : "text"}
        color="secondary"
        variant="standard"
        onChange={(event) => {
          if (isNumber) {
            updateSetting(
              setting.name,
              setting.type,
              Number(event.target.value),
              -1
            );
          } else {
            updateSetting(setting.name, setting.type, event.target.value, -1);
          }
        }}
      />
    );
  }

  function booleanControl() {
    return (
      <Switch
        checked={setting.value}
        // defaultChecked={setting.value}
        onChange={(event) => {
          updateSetting(
            setting.name,
            setting.type,
            event.currentTarget.checked,
            -1
          );
        }}
        color="secondary"
      />
    );
  }

  function arrayControl() {
    return (
      <Select
        value={setting.index}
        color="secondary"
        onChange={(event) => {
          updateSetting(
            setting.name,
            setting.type,
            setting.value,
            Number(event.target.value)
          );
        }}
        sx={{
          marginRight: "0.5em",
        }}
      >
        {setting.value.map((option: string, index: number) => {
          return <MenuItem value={index}>{option}</MenuItem>;
        })}
      </Select>
    );
  }

  function getControl() {
    switch (setting.type) {
      case "number":
        return inputControl(true);
      case "array":
        return arrayControl();
      case "boolean":
        return booleanControl();
      case "string":
        return inputControl(false);
    }
  }

  function wrap() {
    if (setting.children.length > 0) {
      return (
        <Accordion
          variant="outlined"
          sx={{
            backgroundColor: gray,
            borderColor: "transparent",
            padding: 0,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography
              color="secondary"
              
              sx={{
                margin: "0.5em",
              }}
            >
              Subsettings
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {setting.children.map((childSetting) => {
              return (
                <SettingView
                  key={childSetting.name}
                  setting={childSetting}
                  updateSetting={updateSetting}
                />
              );
            })}
          </AccordionDetails>
        </Accordion>
      );
    }
  }

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        marginTop: "0.5em",
        marginBottom: "0.5em",
        padding: "0em",
        backgroundColor: gray,
        borderRadius: "5px",
      }}
      elevation={6}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "center",
          alignItems: "center",
          marginTop: "0.5em",
          marginBottom: "0.5em",
          // padding: "0.5em",
          backgroundColor: gray,
          borderRadius: "5px",
        }}
      >
        <Typography
          color="secondary"
          fontWeight={"bold"}
          sx={{
            margin: "0.5em",
          }}
        >
          {setting.name}
        </Typography>
        <>{getControl()}</>
      </div>
      {wrap()}
      <div style={{ marginRight: "0.5em" }} />
    </Paper>
  );
}
